/* eslint-disable @typescript-eslint/no-explicit-any */

import ArticleEntry from '@/components/ArticleEntry'
import Image from '@/components/Image'
import PresentationEntry from '@/components/PresentationEntry'
import QuizEntry from '@/components/QuizEntry'
import ResourceEntry from '@/components/ResourceEntry'
import { TalkingEntry } from '@/components/TalkingCards'
import VideoPlayer from '@/components/VideoPlayer'
import YouTube from '@/components/YouTube'

import blockContentSerializers from '@/helpers/block-content-serializers'
import BlockContent from '@sanity/block-content-to-react'

import BEMHelper from '@/helpers/bem'
import styles from './styles/Sections.module.scss'
const bem = BEMHelper(styles)

import type { Section } from './index'

interface Props {
  sections: Section[]
  auxhilary: {
    article: any[]
    quiz: any[]
    presentation: any[]
  }
}

export default function Sections({ sections, auxhilary }: Props) {
  return (
    <div {...bem('')}>
      {sections.map((section) => {
        const video = !!(
          section.asset?._type === 'video' && section.asset.video?.video?.asset?.playbackId
        )
        const youtube = section.asset?._type === 'video' && section.asset.id
        const article = section.asset?._type === 'article'
        const quiz = section.asset?._type === 'quiz'
        const presentation = section.asset?._type === 'presentation'
        const resource = section.asset?._type === 'resource'
        const picture = section.asset?._type === 'picture' && section.asset.image
        const talkingCard = section.asset?._type === 'talkingType'

        const auxhilaryAsset = auxhilary?.[section?.asset?._type]?.find(
          ({ _id }) => section.asset._id === _id,
        )

        return (
          <section key={section._key} id={section._key} {...bem('item')}>
            <div {...bem('content')}>
              <h2 {...bem('title')}>{section.title}</h2>

              <BlockContent
                {...bem('text')}
                renderContainerOnSingleChild
                blocks={section.text}
                serializers={blockContentSerializers}
              />
            </div>

            {section.asset && (
              <aside {...bem('aside')}>
                {video && (
                  <VideoPlayer
                    playbackId={section.asset.video?.video?.asset?.playbackId ?? ''}
                    caption={section.asset.caption}
                    title={section.asset.title}
                    aspectRatio={undefined}
                  />
                )}
                {youtube && <YouTube id={section.asset.id} caption={section.asset.caption} />}
                {article && <ArticleEntry {...section.asset} data={auxhilaryAsset} />}
                {quiz && <QuizEntry {...section.asset} data={auxhilaryAsset} />}
                {presentation && (
                  <PresentationEntry {...section.asset} modal data={auxhilaryAsset} />
                )}
                {resource && <ResourceEntry.Item {...section.asset} square large={false} />}
                {picture && (
                  <Image {...section.asset.image} alt={section.asset.image.alt ?? ''} expandable />
                )}
                {talkingCard && <TalkingEntry {...section.asset} />}
              </aside>
            )}
          </section>
        )
      })}
    </div>
  )
}
